import { NavigationBackButton } from '../../navigation';
import { NavigationBar } from '../../common';
import { AcceptSwap } from './AcceptSwap';
import { getAcceptSwapTranslations } from './getAcceptSwapTranslations';
import { TFunction } from 'i18next';
import { initServerTranslation } from '@bts-web/utils-lokalise';
import { redirect } from 'next/navigation';
import { getServerFeatureFlag } from '../../statsig/sdk/server';
import { createSwapOffer } from './server-functions/createSwapOffer';
import { CancelTradeWithConfirmButton } from '../Reusable/CancelTradeConfirmationModal/CancelTradeWithConfirmButton';
import { GenericErrorMessage } from '../../layouts/GenericErrorMessage/GenericErrorMessage';

export const AcceptSwapController = async ({
  sourceAssetId,
  searchParams,
}: {
  sourceAssetId: string;
  searchParams: Promise<Record<string, string>>;
}) => {
  const { t } = await initServerTranslation();

  const translations = getAcceptSwapTranslations(t as TFunction);

  const feature_hasSwapTradeEnabled = await getServerFeatureFlag(
    'feature_hasSwapTradeEnabled',
  );

  if (!feature_hasSwapTradeEnabled) {
    redirect('/portfolio');
  }

  const params = await searchParams;

  const { targetAssetId, amount, amountFor } = params;

  if (!targetAssetId || !amount || !amountFor) {
    redirect('/portfolio');
  }

  const amountForUppercased = amountFor.toUpperCase() as 'SOURCE' | 'TARGET';

  if (amountForUppercased !== 'SOURCE' && amountForUppercased !== 'TARGET') {
    redirect('/portfolio');
  }

  const { data: initialOfferData, errors } = await createSwapOffer({
    sourceAssetId,
    targetAssetId,
    amount,
    amountDefinedFor: amountForUppercased,
  });

  if (errors || !initialOfferData) {
    return <GenericErrorMessage />;
  }

  return (
    <>
      <NavigationBar
        showBorderBottom
        title={translations.summary}
        NavigationLeftSlot={<NavigationBackButton />}
        NavigationRightSlot={
          <CancelTradeWithConfirmButton translations={translations} />
        }
      />

      <AcceptSwap
        translations={translations}
        initialOfferData={initialOfferData}
        amountFor={amountForUppercased}
      />
    </>
  );
};
